webpackJsonp([74],{

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1282);


/***/ }),

/***/ 1282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(179);

var _datetime2 = _interopRequireDefault(_datetime);

var _ja = __webpack_require__(796);

var _ja2 = _interopRequireDefault(_ja);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('ja', _ja2.default);

/***/ })

},[1281]);


// WEBPACK FOOTER //
// app/datetime.ja-b21d168a5f7ef0c27636.js